import React, { ReactNode, useEffect } from "react";
import { useTabContext } from "context/TabContext";

interface TabContainerProps {
  children: ReactNode;
  defaultActiveKey: string;
}

const TabContainer: React.FC<TabContainerProps> = ({
  children,
  defaultActiveKey,
}: TabContainerProps) => {
  const {changeTab} = useTabContext();
  useEffect(() => {
    changeTab(defaultActiveKey);
  }, [])
  return (
      <React.Fragment>
        {children}
      </React.Fragment>
  )
};

export { TabContainer };
